export default "__VITE_ASSET__DcwZ1Eu4__"